import React from "react"
import { Helmet } from "react-helmet"
interface ISeoProps { 
  title : string , 
  description :string
}
export const Seo = ({title, description}:ISeoProps) => <Helmet>
<title>{title} </title>
<meta name="description" content={description} />
</Helmet>